import api from 'api';
import storage from "@/cflow/storageService";

class infoDash {

    labView() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.defaults.headers['Content-Type'] = 'application/json'
            api.get('/infoDash/labView?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new infoDash();